import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'changeMonthNumberToName',
})
export class ChangeMonthNumberToNamePipe implements PipeTransform {
  constructor() {}
  transform(value: any, args?: any): any {
    let months = [
      'main.months.january',
      'main.months.february',
      'main.months.march',
      'main.months.april',
      'main.months.may',
      'main.months.june',
      'main.months.july',
      'main.months.august',
      'main.months.september',
      'main.months.october',
      'main.months.november',
      'main.months.december',
    ];
    return months[value - 1];
  }
}
